import { z } from "zod";

export const assetSchema = z.object({
  source: z.string(),
  type: z.string(),
});

export const createTicketBodySchema = z.object({
  title: z.string(),
  assets: z.array(assetSchema),
  contextAssets: z.array(assetSchema).optional(),
  context: z.string().optional(),
});

export type CreateTicketBody = z.infer<typeof createTicketBodySchema>;

export const createTicketRequest = z.object({
  body: createTicketBodySchema,
});

export const presignedURLRequestBody = z.object({
  fileName: z.string(),
  fileType: z.string(),
  isContextAsset: z.boolean().optional().default(false),
  assetContext: z
    .object({
      name: z.string().optional().nullable(),
      context: z.string().optional().nullable(),
      instructions: z.string().optional().nullable(),
    })
    .optional()
    .nullable(),
});

export const presignedURLRequest = z.object({
  body: presignedURLRequestBody,
});

export const presignedURLResponse = z.object({
  url: z.string(),
  fields: z
    .object({
      key: z.string(),
      bucket: z.string(),
    })
    .passthrough(),
});
